import FarmList from "./FarmList";
import FarmListPageStyle from "../../assets/stylesheets/farm-list/FarmListPage.module.css";
import Logger from "../../utils/logger";

// const log = Logger.create('FarmListPage');

export default function FarmDetailPage() {
  return (
    <main className={FarmListPageStyle["list-main-content"]}>
      <FarmList />
      
    </main>
  );
}
